import React from "react";
import { animated } from "react-spring";

const Toast = ({ style }) => {
  return (
    <animated.div
      style={{
        ...style,
        position: "fixed",
        bottom: "1vw",
        left: "1vw",
        backgroundColor: "green",
        padding: "1vw",
        color: "#fff",
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
      }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#fff" width="1.1vw">
        <g id="Layer_2" data-name="Layer 2">
          <g id="checkmark-circle-2">
            <g id="checkmark-circle-2-2" data-name="checkmark-circle-2">
              <rect />
              <path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" />
              <path d="M14.7,8.39l-3.78,5L9.29,11.28a1,1,0,0,0-1.58,1.23l2.43,3.11a1,1,0,0,0,.79.38h0a1,1,0,0,0,.79-.39l4.57-6a1,1,0,1,0-1.6-1.22Z" />
            </g>
          </g>
        </g>
      </svg>
      <span style={{ marginLeft: "0.5vw" }}>Password changed successfully</span>
    </animated.div>
  );
};

export default Toast;
